<div class="flex flex-col items-center">
  <div class="size-8 rounded-full bg-blue-500"></div>
  <div class="h-[1lh] w-1 bg-blue-500"></div>
</div>
